// Extra functionality for wagtail footnotes
import windowScrollTo from "./window-scroll";
export default function () {
  window.addEventListener("load", function () {
    if (window.location.hash) {
      var hash = window.location.hash;
      var section = document.querySelector(hash);

      if (section !== null) {
        setTimeout(function () {
          windowScrollTo(section, 40);
        }, 2);
      }
    }
  });
  var footnoteSentenceLinks = document.querySelectorAll("[data-article-footnote-link]");
  footnoteSentenceLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      var id = e.target.getAttribute("href");
      var section = document.querySelector(id);
      setTimeout(function () {
        windowScrollTo(section, 40);
      }, 1);
    });
  });
}